.workflow-view-footer {
  background-color: var(--background-color-step-100);
}

.workflow-view-footer__toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.workflow-view-footer__button-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}

.workflow-view-footer__button-content ion-icon {
  font-size: 24px;
}

.workflow-view-footer__button-content span {
  font-size: 12px;
}

.footer-button-inactive {
  opacity: 0.4;
}

.footer-button-active {
  opacity: 1;
}

.workflow-view-footer__buttons-container ion-buttons {
  justify-content: center;
  gap: 2rem;
}
